<template>
  <div id="upload_file" class="upload uploadAll" :is_require="this.UpFile.is_require" :name="this.UpFile.name">
    <div class="load-bl">
      <h5 class="tit">
        {{this.UpFile.title}}
        <span v-show="this.UpFile.is_require == 1" style="color: #cf5454;margin-left: 5px;">*</span>
        <!--   <a class="uploadVideoShow" href="javascript:void(0);" @click="fn">我已上传的<i class="icon-r"></i></a>-->
      </h5>
      <div class="uploa-bg">
        <div class="load-inner">

          <div v-if="MyUploadVideo.length>0" class="load-link load-over" style="margin-bottom: 15px;" v-for="(item,ind) in MyUploadVideo">
            <!-- <span class="pic-del" @click="delFile(ind)">×</span> -->
            <div class="pic-b pic-v">
              <img :src="item.file.image_url" alt="" @click="needScan(ind, item.file.image_url )" v-if="item.file_type === 'image'" />
              <img :src="item.file.thumb_url" alt="" v-else />
            </div>
            <p  :attr-uuid="item.file_id" class="" style="padding-left: 10px;max-height: 50px">{{item.file.title}}</p>
            <!--<span>上传成功！</span>-->
          </div>

          <div class="load-link load-over videoFile" style="margin-bottom: 15px;" v-for="(item,ind) in fileName">
            <span class="pic-del" @click="updateFile(ind)">×</span>
            <div class="pic-b pic-v">
              <img :src="arrayFile[ind]" alt="" @click="needScan(ind)" v-if="arrType[ind]===2" />
              <img :src="arrayFile[ind]" alt="" v-else />
            </div>
            <p :attr-uuid="arrayUuid[ind]" :attr-type="arrType[ind]" class="fileName" style="padding-left: 10px;max-height: 50px">{{arrayName[ind]}}</p>
            <!--<span>上传成功！</span>-->
          </div>
          <div id="videoContainer" class="load-link" @click="upload">
            <div class="pic-b">
            </div>
          </div>
        </div>
        <p class="et-load-info et-video-info" :class="classObj" ref="p_info" @click="allTetx" v-if="this.UpFile.tip" style="margin-top: 10px;font-size: 14px;">
          <span>[要求]</span>
          {{upfileTip}}
        </p>
        <p class="et-load-info et-video-info"  @click="allTetx" v-else style="margin-top: 10px;font-size: 14px;">
          <span>[要求]</span>
          支持MPG、MPEG、AVI、MP4、3GP、RM、RMVB、MOV、FLV、ASF格式，且文件大小不超过10gb。
        </p>
      </div>
    </div>
    <!-- 选择类型-->
    <div class="upload-modal large-info-modal modal fade" id="uploadAlet" data-backdrop="static" role="dialog"
         aria-hidden="false" style="background: rgba(0,0,0,.4)">
      <div class="modal-dialog" role="document" style="top:0">
        <div class="modal-content">
          <div class="modal-body">
            <div style="text-align: center;margin-bottom: 30px;font-size: 16px;">
              选择文件类型 <span style="float: right" @click="uploadAlet">X</span>
            </div>
            <div style="height: 4.5rem;" id="uploadAll">
              <div class="uploadDiv active" @click="uploadDiv(1)" attr-type="1">
                <div class="pic-p">
                  <p class="pin-video">
                    <img :src="globalUrl + 'static/dist/img/up-video.png'" alt=""/>
                  </p>
                </div>
              </div>

              <div class="uploadDiv"  @click="uploadDiv(2)" attr-type="2">
                <div class="pic-p">
                  <p class="pin-img">
                    <img :src="globalUrl + 'static/dist/img/up-Provinces.png'" alt=""/>
                  </p>
                </div>
              </div>
            </div>

            <div style="margin-top: 10px;font-size: 14px;">
              <p class="et-load-info et-video-info" @click="allTetx" v-if="this.UpFile.tip">
                <span>[要求]</span>
                {{this.UpFile.tip}}
              </p>
              <p class="et-load-info et-video-info"  @click="allTetx" v-else>
                <span>[要求]</span>
                支持MPG、MPEG、AVI、MP4、3GP、RM、RMVB、MOV、FLV、ASF格式，且文件大小不超过10gb。
              </p>
            </div>
            <div class="modal-inner modal-upload" style="margin-top: 10px;">
              <a href="javascript:void(0);" class="btn-pl-start btn-pl-start1">
                选择文件
              </a>
              <input type="file" id="upload_input" class="upload-input"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--上传弹窗-->
    <div class="upload-modal large-info-modal modal fade" id="uploadModal" data-backdrop="static" role="dialog"
         aria-hidden="false" style="background: rgba(0,0,0,.4)">
      <div class="modal-dialog" role="document" style="top:0">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <div class="group">
                  <label>名称<span>*</span></label>
                  <div class="pl-ipbox">
                    <input id="Textvideo" type="text" placeholder="请输入名称" maxlength="20" />
                  </div>
                </div>
                <div class="group">
                  <label>描述</label>

                  <div class="pl-ipbox">
                    <textarea id="Textareavideo" rows="3" placeholder="请输入描述信息,100字以内" maxlength="100"></textarea>
                  </div>
                </div>
                <a href="javascript:void(0);" class="btn-2 buttonW buttonR" @click="cancel4()">取消</a>
                <a href="javascript:void(0);" class="btn-pl-start btn-pl-start1 buttonW buttonL">开始上传</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--上传弹窗-->
    <div class="upload-modal large-info-modal modal fade" id="uploadFile" data-backdrop="static" role="dialog"
         aria-hidden="false"  style="background: rgba(0,0,0,.5);">
      <div class="modal-dialog" role="document">
        <div class="modal-content"  style="top:0">
          <div class="modal-head">
            我的视频
            <span data-dismiss="modal">X</span>
          </div>
          <div class="modal-body" id="modal-body">
            <ul class="uploadFile-ul clearfix" id="uploadFile-ul">
              <li v-for="(item,v) in allchannel" >
                <dl>
                  <dt  class="pic-box"><img :src="item.video.thumb_url" alt=""  style="border: none"/></dt>
                  <dd>{{item.video.title}}</dd>
                </dl>
              </li>
            </ul>
            <!-- load -->
            <div class="content index-content" style="padding-top: 0" v-if="scrill">
              <div class="id-content-inner">
                <div class="loader">
                  <div class="loader-inner ball-pulse" style="display: block">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--提示-->
    <div class="upload-modal large-info-modal modal fade" id="uploadVideo-al" data-backdrop="static" role="dialog"
         aria-hidden="false" style="background: rgba(0,0,0,.4)">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p class="detailAlert-p Prompt-p">上传格式错误</p>
            <a href="javascript:void(0);" data-dismiss="modal" class="buttonZ">确定</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览 -->
    <div class="scan-mask" v-show="scan.isScan" @click="closeScan">
      <div class="scan-box">
        <img :src="scan.url"><span></span>
      </div>
    </div>
  </div>
</template>


<script>

    export default {
        props: [
            'UpFile',
            'type',
            'id',
            'countArr',
            'appId',
            'audit_level'
        ],
        data ()
        {
            return {
                uptoken: '',
                fileId: '',
                fileName: 0,
                arrayName: [],
                arrayFile: [],
                arrType: [],
                allchannel: [],
                scrill: true,
                page: 1,
                key: '',
                allTyle: false,
                arrayUuid: [],
                numberSize: 0,
                MyUploadVideo: [],
                typeNmae: '',
                globalUrl: API.GlobalUrl,
                scan: {
                    isScan: false,
                    url: '',
                },
                pngSds:  API.GlobalUrl + 'static/dist/img/audit_2.jpg',
                reject_img:   API.GlobalUrl+'static/dist/img/reject_2.jpg',
                upload_success_img: '/images/upload_success_2.jpg',
                moreInfo: false,
                classObj: {
                    active: false,
                    'down-arrow':false,
                    all: false,
                    elips: false,
                },
                upfileTip:'',
            }
        }
        ,
        methods: {
            //操作按钮事件
            allTetx(){
                if(!this.moreInfo) return;
                this.allTyle = !this.allTyle
                if(this.allTyle  == true){
                    // $('.et-video-info').css('white-space','normal');
                    this.classObj = {
                        active: true,
                        'down-arrow':true,
                        all: true,
                        // elips: false,
                    }
                    this.upfileTip = this.UpFile.tip;

                }else{
                    // $('.et-video-info').css('white-space','nowrap');
                    this.classObj = {
                        active: false,
                        'down-arrow':true,
                        all: false,
                        // elips: true,
                    }
                    this.upfileTip = this.UpFile.tip.substr(0,50) + '...';
                }
            },
            upload(){
                $('#uploadAlet').modal('show')
            },
            uploadAlet(){
                $('#uploadAlet').modal('hide')
            },
            uploadDiv(type){
                if(type == 1){
                    $('.uploadDiv').eq(0).addClass('active').siblings().removeClass('active')
                }else{
                    $('.uploadDiv').eq(1).addClass('active').siblings().removeClass('active')
                }
            },
            fn(){
                var that = this
                $('#uploadFile').modal('show');
                this.$http.get(API.GetUploadFileForMe,{params: {file_type: '1',page: '1',pagesize: '10',status: 'pass'}})
                    .then(function (res) {
                        if (res.code == '0') {
                            for(var i=0;i<res.data.length;i++){
                                that.allchannel.push(res.data[i]);
                            }
                            that.$nextTick(function(){
                                setTimeout(function(){
                                    var picWimg = $('.pic-box').width();
                                    var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                                    $('.pic-box').css('height',picHimg)
                                    $('.pic-box img').css({width: picWimg, height: picHimg, visibility: 'visible'});
                                },200)

                            })
                        }
                    });
            },
            cancel4(){
                $('#uploadModal').modal('hide');
                $('#Textvideo').val('');
                $('#Textareavideo').val('');
                $('#upload_input').val('');
            },
            updateFile(idx){
                this.arrayUuid.splice(idx, 1);
                this.arrayName.splice(idx, 1);
                this.fileName--;
                if(this.numberSize  > this.arrayName.length + this.MyUploadVideo.length){
                    $('#videoContainer').show();
                }
            },
            delFile(idx){
                this.MyUploadVideo.splice(idx,1);
                if(this.numberSize  > this.arrayName.length + this.MyUploadVideo.length){
                    $('#videoContainer').show();
                }
            },
            needScan(idx,url){
                if(url){
                    this.scan.url =  url;
                }else{

                    this.scan.url = this.arrayFile[idx];
                }
                this.scan.isScan = true;
                $('body').addClass('modal-open');
            },
            closeScan(){
                this.scan.isScan = false;
                $('body').removeClass('modal-open');
            },
            initMoreInfo(){
                var pinfo = this.$refs.p_info;
                var offH = pinfo.offsetHeight;
                var scrollH = pinfo.scrollHeight;
                // console.log(pinfo,offH,scrollH);
                if(scrollH > offH){
                    this.moreInfo = true;
                    this.classObj = {
                        active: false,
                        all:false,
                        // elips:true,
                        'down-arrow':true,
                    }
                    this.upfileTip = this.UpFile.tip.substr(0,50) + '...';
                }
            },
        }
        ,
        created: function(){
            this.upfileTip = this.UpFile.tip;
        },
        mounted: function () {
            //操作DOM
            var that = this,
                subscription;
            var id = this.$route.params.id;
            this.initMoreInfo();
            that.typeNmae = that.UpFile.field_type;
            // if (this.UpFile.field_type == 'uploadvideo') {
            if(that.UpFile.choose_num == '0'){
                $('.uploadVideo').hide();
                return false
            }
            if(that.type != 0){
                that.ByUserid = {
                    activity_id: that.id
                };
                // console.log( that.ByUserid )
                this.$http.get(API.GetActivityFileByUserid, {params: that.ByUserid})
                    .then(function (res) {
                        //  console.log(res)
                        if (res.code == 0) {
                            for (var i = 0; i < res.data.length; i++) {
                                that.MyUploadVideo.push(res.data[i]);
                                // console.log(i)
                            }
                        }
                        that.arrayUuid=[];
                        that.arrayName=[];
                        that.fileName=0;
                        if(!that.UpFile.choose_num){
                            that.numberSize = 1
                        }else{
                            that.numberSize =  that.UpFile.choose_num;
                        }
                        if(that.numberSize == '' || that.numberSize == null || that.numberSize<= res.total){
                            $('#videoContainer').hide();
                        }
                    });

            }else{
                // console.log(that.UpFile)
                that.numberSize = that.UpFile.choose_num;
            }
            //that.Uptoken();
            // }
            //$('#uploadAlet').modal('show')


            $('#upload_input').unbind().change(function(){
                if(id == '100071' || that.id == '100071'){
                    $('#Textvideo').val('我的观后感')
                }else{
                    $('#Textvideo').val('');
                }
                $('#Textareavideo').val('');
                var file = this.files[0];  //文件
                var key = file.name;   //文件总名
                var name = key.split('.');
                var ext = name[name.length-1].toLowerCase();
                // var ext =  key.split('.')[1].toLowerCase();
                var tokenUrl = '';
                var type = $('#uploadAll').find('.active').attr('attr-type');
                var file_type = "0";
                if(type == 1){
                    // tokenUrl = API.UploadToken;
                    if (ext != 'mkv' && ext != 'm4v' && ext != 'dv' && ext != 'dvix' && ext != 'hlv' && ext != 'f4v' && ext != 'dat' && ext != 'wmv' && ext != 'mpg' && ext != 'mpeg' && ext != 'avi' && ext != 'mp4' && ext != '3gp' && ext != 'rm' && ext != 'rmvb' && ext != 'mov' && ext != 'flv' && ext != 'asf') {
                        $('#uploadImg-al .detailAlert-p').html('上传格式错误');
                        $('#uploadVideo-al').modal('show');
                        $('#upload_input').val('');
                        return false;
                    }
                    var fileSize = file.size / 1024 / 1024 / 1024;
                    if(fileSize > 20){
                        $('#uploadImg-al .detailAlert-p').html('视频大小不能超过20GB');
                        $('#uploadVideo-al').modal('show');
                        $('#upload_input').val('');
                        return false;
                    }
                    file_type = "1";
                }else{
                    // tokenUrl = API.ImageToken;
                    if (ext != 'jpg' && ext != 'gif' && ext != 'png' && ext != 'jpeg') {
                        $('#uploadImg-al .detailAlert-p').html('上传格式错误');
                        $('#uploadVideo-al').modal('show');
                        $('#upload_input').val('');
                        return false;
                    }
                    var fileSize = file.size / 1024 / 1024;
                    if(fileSize > 20){
                        $('#uploadImg-al .detailAlert-p').html('图片大小不能超过20MB');
                        $('#uploadVideo-al').modal('show');
                        $('#upload_input').val('');
                        return false
                    }
                    file_type = "2";
                }

                    var params = key.split('.')[0]; //文件名


                    //进度
                    var next = function(response) {
                        var file = response;
                        //console.log(file);
                        var size = file.size/1024/1024;
                        var loaded = file.loaded/1024/1024;
                        //总大小
                        $('.SizeBox').html(size.toFixed(2));
                        //已上传
                        $('.SecondBox').html(loaded.toFixed(2));
                        //上传进度
                        $('.pl-num').children('span').html(file.percent.toFixed(2));
                        //上传进度条
                        $('.pl-gro-bar').css('width',file.percent + '%');
                    };
                    //保错
                    var error = function(err) {
                        console.log(err);
                        $('#uploadImg-al .detailAlert-p').html('上传错误')
                        $('#uploadVideo-al').modal('show')
                    };
                    //上传成功
                    var complete = function(isSuccess ,code , backData) {
                        // console.log(res);
                        if(isSuccess){
                            var userData = JSON.parse(ALY.util.base64.decode(backData.userData)).Vod.UserData
                            ++that.fileName;
                            // if(res.data.file_path){
                            //     that.arrType.push(2);
                            //     that.arrayFile.push('https://' + res.data.bucket +  'ishow.cctv.com/' +res.data.file_path + '?imageView2/1/w/60/h/60')
                            // }else{
                            //     that.arrType.push(1);
                            //     that.arrayFile.push('https://ishow.cctv.com/images/video.jpg')
                            // }
                            if(userData.file_type == "2"){
                                that.arrType.push(2);
                                that.arrayFile.push('/images/video.jpg')

                            }else{
                                that.arrType.push(1);
                                that.arrayFile.push('/images/video.jpg')
                            }
                            that.arrayUuid.push(userData.file_id);
                            that.arrayName.push($('#Textvideo').val());
                            $('#processModal').modal('hide');
                            $('#Textvideo').val('');
                            $('#Textareavideo').val('');
                            $('#upload_input').val('');
                            if(that.numberSize  <= that.arrayName.length + that.MyUploadVideo.length){
                                $('#videoContainer').hide();
                            }else{
                                //  that.Uptoken();
                            }
                        }else{
                            $('#processModal').modal('hide');
                            $('#Textvideo').val('');
                            $('#Textareavideo').val('');
                            $('#upload_input').val('');
                            $('.detailAlert-p').html('上传失败')
                            $('#uploadVideo-al').modal('show')
                        }
                    };
                    //console.log(observable)
                    $('#uploadModal').modal('show');
                    //上传
                    $('.btn-pl-start1').unbind('click').on('click', function () {
                        if ($('#Textvideo').val().trim() == '') {
                            $('#Textvideo').focus()
                        }  else {
                            // putExtra.params['x:title'] = $('#Textvideo').val();
                            // if($('#Textareavideo').val()){
                            //     putExtra.params['x:description'] = $('#Textareavideo').val();
                            // }else{
                            //     putExtra.params['x:description'] = $('#Textvideo').val();
                            // }
                            //
                            // if(that.$route.params.id == 0){
                            //     putExtra.params['x:activity_id'] =  that.id;
                            // }else{
                            //     putExtra.params['x:activity_id'] = that.$route.params.id || that.id;
                            // }
                            // /* putExtra.params['x:activity_id'] = that.$route.params.id || that.id;*/
                            // putExtra.params['x:source'] = '1';
                            // putExtra.params['x:audit_level'] = '2';
                            // putExtra.params['x:app_id'] = that.appId;
                            // //putExtra.params['x:event_id'] = '1000';

                            var params = {}
                            params.title = $('#Textvideo').val();

                            if($('#Textareavideo').val()){
                                params.description = $('#Textareavideo').val();
                            }else{
                                params.description = $('#Textvideo').val();
                            }

                            if(that.$route.params.id == 0){
                                params.activity_id = that.id;
                            }else{
                                params.activity_id = that.$route.params.id || that.id;
                            }

                            params.source = "1";
                            // params.audit_level = '2';
                            params.app_id = that.appId;
                            params.audit_level = that.audit_level;
                            console.log("upload" + params.audit_level);
                            var content = {
                                file: file,          //文件名 必填
                                file_type:file_type,
                                Biography: params
                            };
                            $('#uploadAlet').modal('hide');
                            $('#uploadModal').modal('hide');
                            $('#processModal').modal('show');
                            $.fn.uploadHandle(content,function () {
                                console.log("开始上传！");
                            },next, complete);

                        }
                    });
                    //取消
                    $('.btn-pl-giveup').unbind('click').on('click', function () {
                        $.fn.stopUploadFile();
                        $.fn.cancleUploadFile();
                        $.fn.deleteUploadFile();
                        $('#Textimg').val('');
                        $('#Textareavideo').val('');
                        $('#upload_input').val('');
                    });
                // that.$http.get(tokenUrl,{params: {activity_id: that.$route.params.id,app_id: that.appId}})
                //     .then(function (res) {
                //         if(res.code == 0){
                //             $('#uploadAlet').modal('hide');
                //             that.key = res.data.fileId;
                //             that.fileId = res.data.fileId;
                //             that.uptoken = res.data.uptoken;
                //
                //             that.$nextTick(function(){
                //                 var params = key.split('.')[0]; //文件名
                //                 // var domain ='upload-cc';  //域名
                //                 var putExtra = {
                //                     fname: key,
                //                     params: {},
                //                     mimeType: null
                //                 };
                //                 //文件配置
                //                 var config = {
                //                     useCdnDomain: true,
                //                     disableStatisticsReport: false,
                //                     retryCount: 6
                //                     //region: ''  //上传区域
                //                 };
                //                 //进度
                //                 var next = function(response) {
                //                     var file = response.total;
                //                     //console.log(file);
                //                     var size = file.size/1024/1024;
                //                     var loaded = file.loaded/1024/1024;
                //                     //总大小
                //                     $('.SizeBox').html(size.toFixed(2));
                //                     //已上传
                //                     $('.SecondBox').html(loaded.toFixed(2));
                //                     //上传进度
                //                     $('.pl-num').children('span').html(file.percent.toFixed(2));
                //                     //上传进度条
                //                     $('.pl-gro-bar').css('width',file.percent + '%');
                //                 };
                //                 //保错
                //                 var error = function(err) {
                //                     console.log(err);
                //                     $('#uploadImg-al .detailAlert-p').html('上传错误')
                //                     $('#uploadVideo-al').modal('show')
                //                 };
                //                 //上传成功
                //                 var complete = function(res) {
                //                     // console.log(res);
                //                     if(res.code == 0){
                //                         ++that.fileName;
                //                         if(res.data.file_path){
                //                             that.arrType.push(2);
                //                             that.arrayFile.push('https://' + res.data.bucket +  'ishow.cctv.com/' +res.data.file_path + '?imageView2/1/w/60/h/60')
                //                         }else{
                //                             that.arrType.push(1);
                //                             that.arrayFile.push('https://ishow.cctv.com/images/video.jpg')
                //                         }
                //                         that.arrayUuid.push(res.data.uuid);
                //                         that.arrayName.push($('#Textvideo').val());
                //                         $('#processModal').modal('hide');
                //                         $('#Textvideo').val('');
                //                         $('#Textareavideo').val('');
                //                         $('#upload_input').val('');
                //                         if(that.numberSize  <= that.arrayName.length + that.MyUploadVideo.length){
                //                             $('#videoContainer').hide();
                //                         }else{
                //                             //  that.Uptoken();
                //                         }
                //                     }else{
                //                         $('#processModal').modal('hide');
                //                         $('#Textvideo').val('');
                //                         $('#Textareavideo').val('');
                //                         $('#upload_input').val('');
                //                         $('.detailAlert-p').html('上传失败')
                //                         $('#uploadVideo-al').modal('show')
                //                     }
                //                 };
                //                 var observable = qiniu.upload(file, that.key + '.' + ext, that.uptoken, putExtra, config);
                //                 //console.log(observable)
                //                 var subObject = {
                //                     next: next,
                //                     error: error,
                //                     complete: complete
                //                 };
                //                 $('#uploadModal').modal('show');
                //                 //上传
                //                 $('.btn-pl-start1').unbind('click').on('click', function () {
                //                     if ($('#Textvideo').val().trim() == '') {
                //                         $('#Textvideo').focus()
                //                     }  else {
                //                         putExtra.params['x:title'] = $('#Textvideo').val();
                //                         if($('#Textareavideo').val()){
                //                             putExtra.params['x:description'] = $('#Textareavideo').val();
                //                         }else{
                //                             putExtra.params['x:description'] = $('#Textvideo').val();
                //                         }
                //
                //                         if(that.$route.params.id == 0){
                //                             putExtra.params['x:activity_id'] =  that.id;
                //                         }else{
                //                             putExtra.params['x:activity_id'] = that.$route.params.id || that.id;
                //                         }
                //                         /* putExtra.params['x:activity_id'] = that.$route.params.id || that.id;*/
                //                         putExtra.params['x:source'] = '1';
                //                         putExtra.params['x:audit_level'] = '2';
                //                         putExtra.params['x:app_id'] = that.appId;
                //                         //putExtra.params['x:event_id'] = '1000';
                //                         $('#uploadModal').modal('hide');
                //                         $('#processModal').modal('show');
                //                         subscription = observable.subscribe(subObject);
                //                     }
                //                 });
                //                 //取消
                //                 $('.btn-pl-giveup').unbind('click').on('click', function () {
                //                     subscription.unsubscribe();
                //                     $('#Textimg').val('');
                //                     $('#Textareavideo').val('');
                //                     $('#upload_input').val('');
                //                 });
                //             })
                //         }else{
                //             that.uptoken = ''
                //         }
                //     })
            });
        }

    }
</script>

<style>
  #upload_file .uploadDiv{
    width: 48%;
    margin: 0 1%;
    float: left;
    border: 1px dashed #ccc;
    padding: 7px 5px;
    height: 4.5rem;
  }
  #upload_file .uploadDiv:after {
    content: "";
    display: table;
    width: 0;
    clear: both
  }
  #upload_file .uploadDiv .pic-p{
    width: 3.4rem;
    height: 3.4rem;
    overflow: hidden;
    margin: 0 auto;
    position: relative;

    background-size: 50% auto;
  }
  #upload_file .uploadDiv .pic-p .pin-video{
    width: 3.4rem;
    height: 3.4rem;
    overflow: hidden;
    margin-top: 8px;;
    /*background: url(../../../static/dist/img/up-video.png) no-repeat;*/
  }
  #upload_file .uploadDiv .pin-img{
    width: 3.4rem;
    height: 3.4rem;
    overflow: hidden;
    margin-top: 8px;;
    /* background: url(../../../static/dist/img/up-Provinces.png) no-repeat;*/
  }
  #upload_file .uploadDiv.active{
    border: 1px solid red;
  }
  #upload_file .modal-upload{
    position: relative;
  }
  #upload_file .upload-input{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
  }
  .scan-mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    /*display: none;*/
  }
  .scan-box{
    padding: 20px;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    text-align: center;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
  .scan-box img{
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
    width: auto;
  }
  .scan-box span{
    height: 100%;
    width: 0;
    display: inline-block;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/UploadToken/upload.vue